import { Page } from '@grandvisionhq/www-next/pages/content'

import { withCms } from '../../cms'

export default withCms({ wrapInContainerPage: false })(Page)
